import React, { useEffect } from "react";
import { RecommendMerchantWrapper } from "./HomeRecommendMerchantStyle";
import HomeContentSubTitle from "./HomeContentSubTitle";
import { useDispatch, useSelector } from "react-redux";
import { HomeCreators } from "redux/modules/home";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const HomeRecommendMerchant = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recommendList = useSelector(
    (state) => state.home.recommendMerchantList
  );

  function splitSaleItemName(items) {
    if (items.includes(",")) {
      return items.split(",");
    }
    return [...items];
  }

  useEffect(() => {
    dispatch(HomeCreators.fetchRecommendMerchantData());
  }, []);
  return (
    <RecommendMerchantWrapper>
      <HomeContentSubTitle
        title="추천 도매상"
        routingTitle="도매상 전체보기"
        path="/market"
      />
      <ul className="recommend-merchant-content">
        <div className="container">
          {recommendList?.map((item) => {
            return (
              <li
                className="contents"
                key={item.whole_id}
                onClick={() => navigate(`/market/${item.whole_id}`)}
              >
                <img src={item.whole_img} alt="" />
                <div className="name-section">
                  <p>{item.market_type}</p>
                  <p>{item.whole_name}</p>
                </div>
                <TagWrapper>
                  {splitSaleItemName(item.items_on_sale).map((item, index) => {
                    return <p key={index}>{item}</p>;
                  })}
                </TagWrapper>
              </li>
            );
          })}
        </div>
      </ul>
    </RecommendMerchantWrapper>
  );
};

const TagWrapper = styled.div`
  padding: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 6px;
  row-gap: 6px;
  overflow-x: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  p {
    background-color: #fff8f0;
    border-radius: 4px;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #ff7a00;
    padding: 0px 6px;
    white-space: nowrap;
  }
`;

export default HomeRecommendMerchant;
